import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Show } from '../model/recital';

export interface UpdateShowParams {
  recitalId: string;
  showId: string;
  name?: string;
  showDate?: string;
  orderInRecital?: number;
  capacity?: number;
  notes?: string;
}

export const updateShowAPI = async ({
  recitalId,
  showId,
  ...params
}: UpdateShowParams) => {
  const response = await baseAPI.patch<Show>(
    `/recitals/${recitalId}/shows/${showId}`,
    params,
  );
  return response.data;
};

export const useUpdateShowMutation = () => {
  return useMutation({
    mutationFn: async (params: UpdateShowParams) => {
      return await updateShowAPI(params);
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.RECITALS, variables.recitalId, KEYS.SHOWS],
      });
      void queryClient.invalidateQueries({
        queryKey: [
          KEYS.RECITALS,
          variables.recitalId,
          KEYS.SHOWS,
          variables.showId,
        ],
      });
    },
  });
};
